import React from 'react';
import LogoSvg from '../images/logo-faktoria.svg';
import styles from './LogoFW.scss';

type Props = {
  isAnim?: boolean;
  style?: React.CSSProperties | undefined;
};

function LogoFW({ isAnim, style }: Props) {
  if (isAnim === true) {
    return <img src={LogoSvg} className={`${styles.anim} ${styles.fw_logo}`} alt="logo" />;
  }
  return <img src={LogoSvg} className={`${styles.fw_logo}`} alt="logo" style={style} />;
}
LogoFW.defaultProps = {
  isAnim: false,
  style: undefined,
};

export default LogoFW;
